import { Injectable, InjectionToken, Provider, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiEndpointKeyType } from '@bindoc-projects/app-config-domain-lib';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { VirtualClinicApi } from '@bindoc-projects/virtual-clinic-lib/data';
import { KostDataImportProcessData } from '../import-process';

const ARCHIVE_UPLOAD_ENDPOINT = new InjectionToken<ApiEndpointKeyType>(
  'KOST_ARCHIVE_UPLOAD_ENDPOINT',
);

/** Shared multipart protocol for AT/CH; country processors remain in their apps. */
@Injectable()
export class KostDataImportArchiveUploadService {
  private readonly http = inject(HttpClient);
  private readonly api = new VirtualClinicApi(
    inject(BdAppEnvironmentService).load(inject(ARCHIVE_UPLOAD_ENDPOINT)),
  );

  /** Reports upload progress; the last event is the response. */
  upload(processData: KostDataImportProcessData) {
    const body = new FormData();
    body.append(
      'file',
      processData.data.output.transformed,
      processData.data.input.name,
    );
    return this.http.post(
      this.api.virtualClinicById(processData.virtualClinicId) +
        'cases/imports/',
      body,
      { observe: 'events', reportProgress: true },
    );
  }
}

export function provideKostDataImportArchiveUpload(
  endpoint: ApiEndpointKeyType,
): Provider[] {
  return [
    { provide: ARCHIVE_UPLOAD_ENDPOINT, useValue: endpoint },
    KostDataImportArchiveUploadService,
  ];
}
